/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Reminders from './reminders';
import RemindersDetail from './reminders-detail';
import RemindersUpdate from './reminders-update';
import RemindersDeleteDialog from './reminders-delete-dialog';

const RemindersRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Reminders />} />
    <Route path="new" element={<RemindersUpdate />} />
    <Route path=":id">
      <Route index element={<RemindersDetail />} />
      <Route path="edit" element={<RemindersUpdate />} />
      <Route path="delete" element={<RemindersDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default RemindersRoutes;
